// https://github.com/jquense/yup
// Dead simple Object schema validation

import * as yup from "yup";

const companyYupSchema = yup.object().shape({
  name: yup.string().required("Name is required."),
  description: yup.string().max(200, "Description must fewer than 200 characters."),
  headline_custom: yup
    .string()
    .max(200, "Headline must fewer than 200 characters. (Use About Us section for long text.)"),
  website_url: yup
    .string()
    .nullable()
    .test("valid-twitter-url", "Website must be a valid URL or blank.", (value) => {
      if (!value) return true; // Allow blank or null value
      if (!/^https:\/\//.test(value)) return false; // Must start with HTTPS
      return true; // Passes validation
    }),
  twitter_url: yup
    .string()
    .nullable()
    .test("valid-twitter-url", "Twitter URL must be a valid URL or blank.", (value) => {
      if (!value) return true; // Allow blank or null value
      if (!/^https:\/\//.test(value)) return false; // Must start with HTTPS

      let url;
      try {
        url = new URL(value);
      } catch {
        return false;
      }

      // Twitter rebranded to X, but kept twitter.com live -- accept both hosts.
      const TWITTER_HOSTS = ["twitter.com", "www.twitter.com", "x.com", "www.x.com"];
      if (!TWITTER_HOSTS.includes(url.hostname.toLowerCase())) return false;
      return url.pathname.length > 1; // Must be a profile URL, not just the bare host
    }),
  linkedin_url: yup
    .string()
    .nullable()
    .test("valid-twitter-url", "LinkedIn URL must be a valid URL or blank.", (value) => {
      if (!value) return true; // Allow blank or null value
      if (!/^https:\/\//.test(value)) return false; // Must start with HTTPS
      if (!/(www\.|)linkedin.com\/.+/i.test(value)) return false; // Must be a valid Twitter profile URL
      return true; // Passes validation
    }),
  facebook_url: yup
    .string()
    .nullable()
    .test("valid-twitter-url", "Facebook URL must be a valid URL or blank.", (value) => {
      if (!value) return true; // Allow blank or null value
      if (!/^https:\/\//.test(value)) return false; // Must start with HTTPS
      if (!/(www\.|)facebook.com\/.+/i.test(value)) return false; // Must be a valid Twitter profile URL
      return true; // Passes validation
    }),
});

export default companyYupSchema;
